import { render, staticRenderFns } from "./assistant.vue?vue&type=template&id=a6fd3b40&scoped=true&"
import script from "./assistant.vue?vue&type=script&lang=js&"
export * from "./assistant.vue?vue&type=script&lang=js&"
import style0 from "./assistant.vue?vue&type=style&index=0&id=a6fd3b40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fd3b40",
  null
  
)

export default component.exports